import Vue from 'vue'
import Router from 'vue-router'
import {
    getStoredCurrentPlanName,
    getStoredDocumentCreationAccess,
    openFastSpringPage,
    SUBSCRIPTION_ACCESS_ALLOWED,
    SUBSCRIPTION_ACCESS_PREMIUM_REQUIRED
} from '../utils/subscription'

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        if (err && err._isRouter) {
            return;
        }
        return Promise.reject(err);
    });
};
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => {
        if (err && err._isRouter) {
            return;
        }
        return Promise.reject(err);
    });
};

Vue.use(Router);
const routes = new Router({
    // mode: 'history', //后端支持可开
    routes: [
        {path: '/', redirect: '/invoice'},
        {path: '/login', component: resolve => require(['../components/page/Login.vue'], resolve)},
        {path: '/createAccount', component: resolve => require(['../components/page/Login.vue'], resolve), meta: {authMode: 'register'}},
        {
            path: '/aa', component: resolve => require(['../components/common/home.vue'], resolve),
            children: [
                {path: '/client', component: resolve => require(['../components/page/client.vue'], resolve)},
                {path: '/clientUpdate', component: resolve => require(['../components/page/clientUpdate.vue'], resolve)},
                {path: '/clientCreate', component: resolve => require(['../components/page/clientCreate.vue'], resolve)},
                {path: '/item',component: resolve => require(['../components/page/item.vue'], resolve)},
                {path: '/itemCreate',component: resolve => require(['../components/page/itemCreate.vue'], resolve)},
                {path: '/itemUpdate',component: resolve => require(['../components/page/itemUpdate.vue'], resolve)},
                {path: '/invoice', component: resolve => require(['../components/page/invoice.vue'], resolve)},
                {path: '/invoiceCreate',component: resolve => require(['../components/page/invoiceCreate.vue'], resolve), meta: {requiresDocumentCreation: true}},
                {path: '/invoiceUpdate',component: resolve => require(['../components/page/updateInvoice.vue'], resolve)},
                {path: '/setting',component: resolve => require(['../components/page/setting.vue'], resolve)},
                {path: '/company_info',component: resolve => require(['../components/page/companyInfo.vue'], resolve)},
                // {path: '/payment_info',component: resolve => require(['../components/page/paymentInfo.vue'], resolve)},
                {path: '/default',component: resolve => require(['../components/page/default.vue'], resolve)},
                {path: '/invoice-design',component: resolve => require(['../components/page/invoiceDesign.vue'], resolve)},
                {path: '/account',component: resolve => require(['../components/page/account.vue'], resolve)},
                {path: '/feedback',component: resolve => require(['../components/page/feedback.vue'], resolve)},
                {path: '/report',component: resolve => require(['../components/page/report.vue'], resolve)},
                {path: '/expense',component: resolve => require(['../components/page/expenses.vue'], resolve)},
                {path: '/estimate',component: resolve => require(['../components/page/estimate.vue'], resolve)},
                {path: '/purchaseOrder',component: resolve => require(['../components/page/estimate.vue'], resolve)},
                {path: '/creditMemo',component: resolve => require(['../components/page/estimate.vue'], resolve)},
                {path: '/createEstimate',component: resolve => require(['../components/page/createEstimate.vue'], resolve), meta: {requiresDocumentCreation: true}},
                {path: '/updateEstimate',component: resolve => require(['../components/page/updateEstimate.vue'], resolve)},
                {path: '/createExpense',component: resolve => require(['../components/page/CreateExpense.vue'], resolve)},
                {path: '/updateExpense',component: resolve => require(['../components/page/updateExpense.vue'], resolve)},
                {path: '/createStatement',component: resolve => require(['../components/page/createStatement.vue'], resolve)},
                {path: '/time',component: resolve => require(['../components/page/time.vue'], resolve)},
                {path: '/timeCreate',component: resolve => require(['../components/page/timeEdit.vue'], resolve)},
                {path: '/timeUpdate',component: resolve => require(['../components/page/timeEdit.vue'], resolve)}
            ]
        },
        {
            path: '*',
            component: resolve => require(['../components/page/404.vue'], resolve)  // 404
        }
    ]
})

routes.beforeEach((to, from, next) => {
    const publicPaths = ['/login', '/createAccount'];
    if (localStorage.getItem('loginInformation') == null && publicPaths.indexOf(to.path) === -1) {
        next('/login');
        return;
    }
    if (to.meta.requiresDocumentCreation) {
        const access = getStoredDocumentCreationAccess();
        if (access !== SUBSCRIPTION_ACCESS_ALLOWED) {
            openFastSpringPage(
                getStoredCurrentPlanName(),
                access === SUBSCRIPTION_ACCESS_PREMIUM_REQUIRED ? 'Premium' : 'Pro'
            );
            return;
        }
    }
    next();
})

export default routes;
